function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "2295530B-EF0A-4DE3-BE6F-2A1F5702E6CE@3.00x");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "WHS---Dashboard-Expanded",
  transform: "translate(-298.000000, -438.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-3-Copy",
  transform: "translate(25.000000, 310.000000)"
}, React.createElement("g", {
  id: "Group-6",
  transform: "translate(0.000000, 115.000000)"
}, React.createElement("g", {
  id: "outline-wb_sunny-24px",
  transform: "translate(273.000000, 13.000000)"
}, React.createElement("path", {
  d: "M4.50782609,3.3573913 L3.09913043,1.95652174 L1.99565217,3.06 L3.39652174,4.46086957 L4.50782609,3.3573913 Z M0,7.78695652 L2.34782609,7.78695652 L2.34782609,9.35217391 L0,9.35217391 L0,7.78695652 Z M7.82608696,0 L9.39130435,0 L9.39130435,2.30869565 L7.82608696,2.30869565 L7.82608696,0 Z M14.1182609,1.9526087 L15.2201739,3.05373913 L13.8193043,4.4546087 L12.7181739,3.35269565 L14.1182609,1.9526087 Z M12.7095652,13.7817391 L14.1104348,15.1904348 L15.213913,14.0869565 L13.8052174,12.686087 L12.7095652,13.7817391 Z M14.8695652,7.78695652 L17.2173913,7.78695652 L17.2173913,9.35217391 L14.8695652,9.35217391 L14.8695652,7.78695652 Z M8.60869565,3.87391304 C6.01826087,3.87391304 3.91304348,5.97913043 3.91304348,8.56956522 C3.91304348,11.16 6.01826087,13.2652174 8.60869565,13.2652174 C11.1991304,13.2652174 13.3043478,11.16 13.3043478,8.56956522 C13.3043478,5.97913043 11.1991304,3.87391304 8.60869565,3.87391304 Z M8.60869565,11.7 C6.87913043,11.7 5.47826087,10.2991304 5.47826087,8.56956522 C5.47826087,6.84 6.87913043,5.43913043 8.60869565,5.43913043 C10.3382609,5.43913043 11.7391304,6.84 11.7391304,8.56956522 C11.7391304,10.2991304 10.3382609,11.7 8.60869565,11.7 Z M7.82608696,14.8304348 L9.39130435,14.8304348 L9.39130435,17.1391304 L7.82608696,17.1391304 L7.82608696,14.8304348 Z M1.99565217,14.0791304 L3.09913043,15.1826087 L4.5,13.773913 L3.39652174,12.6704348 L1.99565217,14.0791304 Z",
  id: "Shape"
}))))));

var SvgSun = function SvgSun(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSun, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SUN.ff9efb41.svg";
export { ForwardRef as ReactComponent };